import {LitElement, unsafeCSS} from "lit";
import {html} from "lit/static-html.js";
import {
  customElement,
  property,
  queryAssignedElements
} from "lit/decorators.js";
import CheckCircle from "@interstate/icons-svg/check-circle.svg?raw";
import ExclamationCircle from "@interstate/icons-svg/exclamation-circle.svg?raw";
import ExclamationTriangle from "@interstate/icons-svg/exclamation-triangle.svg?raw";
import InformationCircle from "@interstate/icons-svg/information-circle.svg?raw";
import XMark from "@interstate/icons-svg/x-mark.svg?raw";
import styles from "./IdsAlertElement.css?inline";
import {ROOT_TAG} from "../../globals";
import {unsafeStatic} from "lit/static-html.js";
import {InterstateIcon} from "../interstate-icon";

const tagName = `${ROOT_TAG}-interstate-alert`;
export const InterstateAlert = unsafeStatic(tagName);

type AlertVariant = "error" | "info" | "success" | "caution";
const allowCloseButton = ["info", "success"];

@customElement(tagName)
export class IdsAlertElement extends LitElement {
  @property()
  variant: AlertVariant = "info";

  @property()
  header?: string;

  @queryAssignedElements({slot: "title"})
  private _title?: HTMLElement[];

  @property({type: Boolean})
  closable = false;

  static styles = unsafeCSS(styles);

  private iconVariant(variant: AlertVariant) {
    switch (variant) {
      case "caution":
        return ExclamationTriangle;
      case "error":
        return ExclamationCircle;
      case "success":
        return CheckCircle;
      case "info": // cascade intentional
      default:
        return InformationCircle;
    }
  }

  private titleTemplate() {
    if ((this._title?.length || 0) === 0 && !this.header) return;
    return html`<span class="ids-alert-title"
      ><slot name="title">${this.header}</slot></span
    >`;
  }

  private _handleCloseClick() {
    this.remove();
  }

  private closeButtonTemplate() {
    if (this.closable && allowCloseButton.includes(this.variant)) {
      return html`<div class="ids-alert-close">
        <button
          @click=${this._handleCloseClick}
          class="ids-btn"
          data-ids-size="sm">
          <${InterstateIcon}
            svg="${XMark}">
          </${InterstateIcon}>
        </button>
      </div>`;
    }
  }

  override render() {
    return html`
      <div class="ids-alert" data-ids-variant=${this.variant} role="alert">
        <span class="ids-alert-icon">
          <${InterstateIcon}
            svg="${this.iconVariant(this.variant)}">
          </${InterstateIcon}>
        </span>
        <div class="ids-alert-body">
          ${this.titleTemplate()}
          <span class="ids-alert-message">
            <slot></slot>
          </span>
        </div>
        ${this.closeButtonTemplate()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [tagName]: IdsAlertElement;
  }
}
